import User from "app/models/user"
import WorkingHour from "app/models/workingHour"
import State from "../state"
import { Params } from "./users.reducer"

export const loading = (state: State): boolean => state.users.loading
export const getUsers = (state: State): User[] => state.users.data
export const errors = (state: State): object => state.users.errors

export const getUser = (state: State): User | undefined => state.users.user && state.users.user
export const getUserById = (id: string) => (state: State): User | undefined =>
  state.users.data.find(user => user.id === id)

export const getParams = (state: State): Params => state.users.params

export const getUserWorkingHoursGroupedByWeekday = (state: State): WorkingHour[][] | undefined => {
  if (!state.users.user?.preferable_working_hours) {
    return undefined
  }

  const baseDaysArray = [...Array(7).fill([])]
  const workingHours = [...state.users.user?.preferable_working_hours]
  return workingHours.reduce(
    (workingHours: WorkingHour[][], workingHour: WorkingHour) =>
      workingHours.map((day: WorkingHour[], index: number) => {
        if (Number(index) === Number(workingHour.weekday)) {
          return [...day, workingHour]
        }
        return [...day]
      }),
    [...baseDaysArray],
  )
}
